import { useUsers } from '../data/users';

export function TypingIndicator({ userIds }: { userIds: string[] }) {
  const { nameOf } = useUsers();

  // A magassag akkor is megvan, ha nincs mit mutatni - kulonben ugralna a felulet.
  if (userIds.length === 0) return <div aria-hidden="true" className="h-6" />;

  const names = userIds.map((id) => nameOf(id, 'Valaki'));
  const label =
    names.length === 1
      ? `${names[0]} éppen ír`
      : names.length === 2
        ? `${names[0]} és ${names[1]} éppen ír`
        : `${names.length} ember éppen ír`;

  return (
    <div className="h-6 px-4 sm:px-6">
      <p className="mx-auto flex max-w-4xl items-center gap-1.5 text-xs text-ink-muted">
        <span aria-hidden="true" className="flex gap-0.5">
          <Dot delay="0ms" />
          <Dot delay="150ms" />
          <Dot delay="300ms" />
        </span>
        {label}
      </p>
    </div>
  );
}

function Dot({ delay }: { delay: string }) {
  return (
    <span
      className="size-1 animate-bounce rounded-full bg-ink-faint"
      style={{ animationDelay: delay, animationDuration: '900ms' }}
    />
  );
}
